"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTagWrapper = exports.TagWrapper = void 0;
var merch_components_1 = require("@carvana/merch-components");
exports.TagWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'flex h-20 w-fit items-center rounded-full px-8 text-xs font-bold leading-5'
});
exports.StatusTagWrapper = (0, merch_components_1.createComponent)('div', {
    className: 'rounded-br-md px-8 py-4 text-xs font-bold text-white'
});
//# sourceMappingURL=Tags.styles.js.map